import environment from '../services/environment';

export const assetPrefix = !environment.isLocal ? '/reacttools' : '';
